/*
 * Copyright (c) 2025 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Permit } from './permits';

//this is an example of cabinet permits, to be used just for mock-data
export const InspectorCabinet: Permit[] = [
    'DOCUMENT_PICTURE_SCREEN',
    'USER_SETTINGS_INFO_SCREEN',
    'USER_SETTINGS_SECURITY_SCREEN',
    'INSPECTOR_HOME_SCREEN',
    'INFOGRAPHICS_FIN_SCREEN',
    'INFOGRAPHICS_TECH_SCREEN',
    'STATISTICS_SCREEN',
    'ALERTS_LIST_SCREEN',
    'ALERT_DETAILS_SCREEN',
    'REPORTS_SCREEN',
    'STORES_MAP_SCREEN',
    'CASHBOXES_MAP_SCREEN',
    'OPERATORS_LIST_SCREEN',
    'OPERATOR_CARD_SCREEN',
    'COMPANIES_LIST_SCREEN',
    'COMPANY_CARD_SCREEN',
    'STORES_LIST_SCREEN',
    'STORE_CARD_SCREEN',
    'CASHBOXES_LIST_SCREEN',
    'CASHBOX_CARD_SCREEN',
    'DOCUMENTS_LIST_SCREEN',
    'DOCUMENT_CARD_SCREEN',
    'DEVICES_LIST_SCREEN',
    'DEVICE_CARD_SCREEN',
    'CASHREGISTER_MODELS_LIST_SCREEN',
    'CASHREGISTER_MODEL_CARD_SCREEN',
    'CASHREGISTERS_LIST_SCREEN',
    'CASHREGISTER_CARD_SCREEN',
    'REGISTRY_WRAPPER',
    'MAPS_WRAPPER',
    'INFOGRAPHICS_WRAPPER',

    'TURNOVERS',
    'CASHBOX_DOCUMENTS',
    'CASHBOX_MODE_HISTORY',
    'CASHBOX_STATUS_HISTORY',
    'CASHBOX_REPLACEMENT',
    'CASHBOX_CLOCK_STATUS_HISTORY',
    'CASHBOX_AUDIT_DATA',
    'CASHBOX_ALERTS_HISTORY',
    'CASHBOX_GPS_TRACKING',
    'CASHBOX_CHECKSUM_HISTORY',
    'CASHBOX_PERIOD_FILTERS',
    'CASHBOX_HARDWARE_AND_SOFTWARE_DATA',
    'TAX_AUTHORITY',
    'STORE_ACTIVITY',
    'RELATED_COMPANY_DATA',
    'RELATED_OPERATOR_DATA',
    'DOCUMENT_ID',
    'STORE_COORDINATES_TAB',
    'STORE_PHOTO_GALLERY',
    'STORE_INSPECTION_DATA',
    'COMPANY_STORES',
    'COMPANY_CASHBOXES_STATS',
    'CASHREGISTER_STATUS_HISTORY',
    'CASHREGISTER_MODEL_DOCUMENTS',
    'CASHREGISTER_MODEL_STATUS_HISTORY',
    'CASHREGISTER_MODEL_SOFTWARE_VERSIONS_HISTORY',
    'CASHREGISTER_MODEL_ATTESTATION_KEY',
    'CASHREGISTER_MODELS_FILTER',
    'RRN_FILTER',
    'RESTORED_DOCUMENT',
    'USER_WITH_TAX_AUTHORITY',
    'ALERT_ASSIGNEE_USERS_LIST',

    'DELETE_STORE_PHOTO_ACTION',
    'EDIT_STORE_COORDINATES_ACTION',
    'EDIT_USER_PHONE_NUMBER_ACTION',

    'ACCESS_ALL_CASHBOXES',
    'ACCESS_ALL_CASHREGISTERS',
    'ACCESS_ALL_CASHREGISTER_MODELS',
    'ACCESS_ALL_COMPANIES',
    'ACCESS_ALL_STORES',
    'ACCESS_ALL_DEVICES',
    'ACCESS_ALL_DOCUMENTS',
    'ACCESS_ALL_REPORTS',
];

const DirectorSpecial: Permit[] = [
    'ADMIN_USERS_LIST_SCREEN',
    'ALERTS_SETTINGS_SCREEN',
    'ALERT_EXECUTION_LOGS_SCREEN',
    'ALERT_RULES_SCREEN',
    'SERVICE_SCREEN',

    'CASHBOX_SERVICE',
    'DEVICE_SERVICE',

    'CHANGE_CASHBOX_STATUS_ACTION',
    'CLOSE_ALERT_ACTION',
    'CASHREGISTER_CREATE_OTP_ACTION',
    'APPOINT_STORE_INSPECTION_ACTION',
    'CANCEL_STORE_INSPECTION_ACTION',
    'MANAGE_CASHREGISTER_MODEL_STATUS_ACTION',
    'FORCE_COMPLETE_MODEL_ATTESTATION_ACTION',
    'SET_CASHREGISTER_MODEL_CATEGORY_ACTION',
    'SET_CASHREGISTER_MODEL_AGENT_TYPE_ACTION',
    'MANAGE_CASHREGISTER_MODEL_SW_VERSION_STATUS_ACTION',
    'MANAGE_CASHREGISTER_MODEL_DOCUMENTS_ACTION',
];

const ExpertSpecial: Permit[] = [
    'SERVICE_SCREEN',

    'CASHBOX_SERVICE',
    'DEVICE_SERVICE',

    'MANAGE_CASHREGISTER_MODEL_STATUS_ACTION',
    'SET_CASHREGISTER_MODEL_CATEGORY_ACTION',
    'SET_CASHREGISTER_MODEL_AGENT_TYPE_ACTION',
    'MANAGE_CASHREGISTER_MODEL_SW_VERSION_STATUS_ACTION',
    'MANAGE_CASHREGISTER_MODEL_DOCUMENTS_ACTION',
];

const AuditorSpecial: Permit[] = ['ASSIGN_STORE_INSPECTION_ACTION', 'COMPLETE_STORE_INSPECTION_ACTION'];

//this is an example of cabinet permits, to be used just for mock-data
export const DirectorCabinet: Permit[] = InspectorCabinet.concat(DirectorSpecial);

//this is an example of cabinet permits, to be used just for mock-data
export const ExpertCabinet: Permit[] = InspectorCabinet.concat(ExpertSpecial);

//this is an example of cabinet permits, to be used just for mock-data
export const AuditorCabinet: Permit[] = InspectorCabinet.concat(AuditorSpecial);

//this is an example of cabinet permits, to be used just for mock-data
export const SuperCabinet: Permit[] = InspectorCabinet.concat(DirectorSpecial, ExpertSpecial, AuditorSpecial);

//this is an example of cabinet permits, to be used just for mock-data
export const CentralInspectorCabinet: Permit[] = [
    'DOCUMENT_PICTURE_SCREEN',
    'USER_SETTINGS_INFO_SCREEN',
    'USER_SETTINGS_SECURITY_SCREEN',
    'CENTRAL_INSPECTOR_INFOGRAPHICS_SCREEN',
    'STATISTICS_SCREEN',
    'REPORTS_SCREEN',
    'STORES_MAP_SCREEN',
    'CASHBOXES_MAP_SCREEN',
    'COMPANIES_LIST_SCREEN',
    'COMPANY_CARD_SCREEN',
    'STORES_LIST_SCREEN',
    'STORE_CARD_SCREEN',
    'CASHBOXES_LIST_SCREEN',
    'CASHBOX_CARD_SCREEN',
    'DOCUMENTS_LIST_SCREEN',
    'DOCUMENT_CARD_PICT_SCREEN',
    'REGISTRY_WRAPPER',
    'MAPS_WRAPPER',

    'TURNOVERS',
    'CASHBOX_DOCUMENTS',
    'CASHBOX_MODE_HISTORY',
    'CASHBOX_STATUS_HISTORY',
    'CASHBOX_REPLACEMENT',
    'CASHBOX_CLOCK_STATUS_HISTORY',
    'CASHBOX_PERIOD_FILTERS',
    'CASHBOX_HARDWARE_AND_SOFTWARE_DATA',
    'CASHREGISTER_MODELS_FILTER',
    'COMPANY_STORES',
    'COMPANY_CASHBOXES_STATS',
    'TAX_AUTHORITY',
    'STORE_ACTIVITY',
    'RELATED_COMPANY_DATA',
    'RELATED_OPERATOR_DATA',
    'RRN_FILTER',
    'USER_WITH_TAX_AUTHORITY',

    'EDIT_USER_PHONE_NUMBER_ACTION',

    'ACCESS_ALL_CASHBOXES',
    'ACCESS_ALL_CASHREGISTER_MODELS',
    'ACCESS_ALL_COMPANIES',
    'ACCESS_ALL_STORES',
    'ACCESS_ALL_DOCUMENTS',
    'ACCESS_ALL_REPORTS',
];

//this is an example of cabinet permits, to be used just for mock-data
export const RegionalInspectorCabinet: Permit[] = [
    'DOCUMENT_PICTURE_SCREEN',
    'USER_SETTINGS_INFO_SCREEN',
    'USER_SETTINGS_SECURITY_SCREEN',
    'REGIONAL_INSPECTOR_INFOGRAPHICS_SCREEN',
    'REPORTS_SCREEN',
    'STORES_LIST_SCREEN',
    'STORE_CARD_SCREEN',
    'CASHBOXES_LIST_SCREEN',
    'CASHBOX_CARD_SCREEN',
    'DOCUMENTS_LIST_SCREEN',
    'DOCUMENT_CARD_PICT_SCREEN',

    'TURNOVERS',
    'CASHBOX_DOCUMENTS',
    'CASHBOX_MODE_HISTORY',
    'CASHBOX_STATUS_HISTORY',
    'CASHBOX_REPLACEMENT',
    'CASHBOX_CLOCK_STATUS_HISTORY',
    'CASHBOX_PERIOD_FILTERS',
    'CASHBOX_HARDWARE_AND_SOFTWARE_DATA',
    'CASHREGISTER_MODELS_FILTER',
    'STORE_ACTIVITY',
    'RELATED_COMPANY_DATA',
    'RELATED_OPERATOR_DATA',
    'RRN_FILTER',
    'USER_WITH_TAX_AUTHORITY',

    'EDIT_USER_PHONE_NUMBER_ACTION',

    'ACCESS_REGIONAL_CASHBOXES',
    'ACCESS_ALL_CASHREGISTER_MODELS',
    'ACCESS_REGIONAL_COMPANIES',
    'ACCESS_REGIONAL_STORES',
    'ACCESS_REGIONAL_DOCUMENTS',
    'ACCESS_REGIONAL_REPORTS',
];

//this is an example of cabinet permits, to be used just for mock-data
export const OperatorCabinet: Permit[] = [
    'USER_SETTINGS_INFO_SCREEN',
    'OPERATOR_HOME_SCREEN',
    'COMPANIES_LIST_SCREEN',
    'COMPANY_CARD_SCREEN',
    'STORES_LIST_SCREEN',
    'STORE_CARD_SCREEN',
    'CASHBOXES_LIST_SCREEN',
    'CASHBOX_CARD_SCREEN',
    'DEVICES_LIST_SCREEN',
    'DEVICE_CARD_SCREEN',
    'CASHREGISTER_MODELS_LIST_SCREEN',
    'CASHREGISTER_MODEL_CARD_SCREEN',
    'CASHREGISTERS_LIST_SCREEN',
    'CASHREGISTER_CARD_SCREEN',
    'SERVICE_SCREEN',

    'CASHBOX_GPS_TRACKING',
    'CASHBOX_LAST_DOCUMENT',
    'CASHBOX_STATUS_HISTORY',
    'CASHBOX_AUDIT_DATA',
    'CASHBOX_SERVICE',
    'CASHBOX_PERIOD_FILTERS',
    'CASHBOX_HARDWARE_AND_SOFTWARE_DATA',
    'STORE_ACTIVITY',
    'STORE_COORDINATES_TAB',
    'STORE_PHOTO_GALLERY',
    'COMPANY_STORES',
    'COMPANY_CASHBOXES_STATS',
    'TAX_AUTHORITY',
    'RELATED_COMPANY_DATA',
    'CASHREGISTER_STATUS_HISTORY',
    'CASHREGISTER_MODEL_FACTORY_NUMBERS',
    'CASHREGISTER_MODEL_SOFTWARE_VERSIONS_HISTORY_FOR_OPERATOR',
    'CASHREGISTER_MODELS_FILTER',
    'USER_WITH_OPERATOR_NAME',

    'CASHREGISTER_CREATE_OTP_ACTION',
    'DELETE_STORE_PHOTO_ACTION',
    'EDIT_STORE_COORDINATES_ACTION',

    'ACCESS_OPERATOR_CASHBOXES',
    'ACCESS_OPERATOR_CASHREGISTERS',
    'ACCESS_OPERATOR_CASHREGISTER_MODELS',
    'ACCESS_OPERATOR_COMPANIES',
    'ACCESS_OPERATOR_STORES',
    'ACCESS_OPERATOR_DEVICES',
];

//this is an example of cabinet permits, to be used just for mock-data
export const TaxpayerCabinet: Permit[] = [
    'USER_SETTINGS_INFO_SCREEN',
    'TAXPAYER_HOME_SCREEN',
    'REPORTS_SCREEN',
    'STORES_LIST_SCREEN',
    'STORE_CARD_SCREEN',
    'CASHBOXES_LIST_SCREEN',
    'CASHBOX_CARD_SCREEN',
    'DOCUMENTS_LIST_SCREEN',
    'DOCUMENT_CARD_PICT_SCREEN',

    'CASHBOX_DOCUMENTS',
    'CASHBOX_MODE_HISTORY',
    'CASHBOX_CLOCK_STATUS_HISTORY',
    'CASHBOX_GPS_TRACKING',
    'CASHREGISTER_MODELS_FILTER',
    'TAX_AUTHORITY',
    'RELATED_OPERATOR_DATA',
    'STORE_COORDINATES_TAB',

    'ACCESS_TAXPAYER_CASHBOXES',
    'ACCESS_ALL_CASHREGISTER_MODELS',
    'ACCESS_TAXPAYER_STORES',
    'ACCESS_TAXPAYER_DOCUMENTS',
    'ACCESS_TAXPAYER_REPORTS',
];
